import * as Types from '../graphql.generated';

import { Seo_FragmentFragment } from './seo.fragment.generated';
import { Ad_Targeting_FragmentFragment } from './adTargeting.fragment.generated';
import { Analytics_Eccomerce_FragmentFragment } from './analyticsEcommerce.fragment.generated';
import { Analytics_Taxonomy_FragmentFragment } from './analyticTaxonomy.fragment.generated';
import { Links_FragmentFragment } from './links.fragment.generated';
import { Listing_Ss_FragmentFragment } from './listingSS.fragment.generated';
import { Meta_Info_FragmentFragment } from './metaInfo.fragment.generated';
import { Pagination_FragmentFragment } from './pagination.fragment.generated';
import { Saved_Search_And_Alerts_FragmentFragment } from './savedSearchAndAlerts.fragment.generated';
import { Seo_Blurb_FragmentFragment } from './seoBlurb.fragment.generated';
import { Seo_Accordions_FragmentFragment } from './seoAccordions.fragment.generated';
import { Listing_FragmentFragment } from './listing.fragment.generated';
import { gql } from '@apollo/client';
import { Seo_FragmentFragmentDoc } from './seo.fragment.generated';
import { Ad_Targeting_FragmentFragmentDoc } from './adTargeting.fragment.generated';
import { Analytics_Eccomerce_FragmentFragmentDoc } from './analyticsEcommerce.fragment.generated';
import { Analytics_Taxonomy_FragmentFragmentDoc } from './analyticTaxonomy.fragment.generated';
import { Links_FragmentFragmentDoc } from './links.fragment.generated';
import { Listing_Ss_FragmentFragmentDoc } from './listingSS.fragment.generated';
import { Meta_Info_FragmentFragmentDoc } from './metaInfo.fragment.generated';
import { Pagination_FragmentFragmentDoc } from './pagination.fragment.generated';
import { Saved_Search_And_Alerts_FragmentFragmentDoc } from './savedSearchAndAlerts.fragment.generated';
import { Seo_Blurb_FragmentFragmentDoc } from './seoBlurb.fragment.generated';
import { Seo_Accordions_FragmentFragmentDoc } from './seoAccordions.fragment.generated';
import { Listing_FragmentFragmentDoc } from './listing.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type LogSearchMutationVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type LogSearchMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'logSearch'
>;

export type ApiSearchByUrlQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type ApiSearchByUrlQuery = { __typename?: 'Query' } & {
    seo?: Types.Maybe<
        | ({ __typename?: 'SeoResults' } & Seo_FragmentFragment)
        | ({ __typename?: 'SeoResultsError' } & Pick<
              Types.SeoResultsError,
              'errorCode'
          >)
    >;
    searchResults?: Types.Maybe<
        { __typename?: 'Results' } & Pick<
            Types.Results,
            'title' | 'userAlertId'
        > & {
                adTargeting?: Types.Maybe<
                    {
                        __typename?: 'AdTargeting';
                    } & Ad_Targeting_FragmentFragment
                >;
                analyticsEcommerce?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsEcommerce';
                    } & Analytics_Eccomerce_FragmentFragment
                >;
                analyticsTaxonomy?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsTaxonomy';
                    } & Analytics_Taxonomy_FragmentFragment
                >;
                links?: Types.Maybe<
                    { __typename?: 'Links' } & Links_FragmentFragment
                >;
                listings?: Types.Maybe<
                    { __typename?: 'Listings' } & {
                        regular?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_Ss_FragmentFragment
                                >
                            >
                        >;
                        extended?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_Ss_FragmentFragment
                                >
                            >
                        >;
                        featured?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_Ss_FragmentFragment
                                >
                            >
                        >;
                    }
                >;
                metaInfo?: Types.Maybe<
                    { __typename?: 'Meta' } & Meta_Info_FragmentFragment
                >;
                pagination?: Types.Maybe<
                    { __typename?: 'Pagination' } & Pagination_FragmentFragment
                >;
                savedSearchAndAlerts?: Types.Maybe<
                    {
                        __typename?: 'SavedSearchAndAlerts';
                    } & Saved_Search_And_Alerts_FragmentFragment
                >;
                seoBlurb?: Types.Maybe<
                    { __typename?: 'SeoBlurb' } & Seo_Blurb_FragmentFragment
                >;
            }
    >;
};

export type GetListingDataQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetListingDataQuery = { __typename?: 'Query' } & {
    breadcrumbs?: Types.Maybe<
        Array<
            { __typename?: 'Breadcrumbs' } & Pick<
                Types.Breadcrumbs,
                'label' | 'tracking' | 'uri' | 'noAppend' | 'i18nLabelKey'
            >
        >
    >;
    redirects?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'Redirect' } & Pick<
                    Types.Redirect,
                    'code' | 'redirectUri'
                >
            >
        >
    >;
    seoAccordions?: Types.Maybe<
        Array<
            Types.Maybe<
                {
                    __typename?: 'SeoAccordions';
                } & Seo_Accordions_FragmentFragment
            >
        >
    >;
    discoverMore?: Types.Maybe<
        { __typename?: 'DiscoverMore' } & Pick<
            Types.DiscoverMore,
            'housePricesUri' | 'findAgentsUri'
        >
    >;
    searchResults?: Types.Maybe<
        { __typename?: 'Results' } & Pick<
            Types.Results,
            'title' | 'userAlertId' | 'polyenc'
        > & {
                analyticsTaxonomy?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsTaxonomy';
                    } & Analytics_Taxonomy_FragmentFragment
                >;
                analyticsEcommerce?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsEcommerce';
                    } & Analytics_Eccomerce_FragmentFragment
                >;
                adTargeting?: Types.Maybe<
                    {
                        __typename?: 'AdTargeting';
                    } & Ad_Targeting_FragmentFragment
                >;
                metaInfo?: Types.Maybe<
                    { __typename?: 'Meta' } & Meta_Info_FragmentFragment
                >;
                pagination?: Types.Maybe<
                    { __typename?: 'Pagination' } & Pagination_FragmentFragment
                >;
                listings?: Types.Maybe<
                    { __typename?: 'Listings' } & {
                        regular?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_FragmentFragment
                                >
                            >
                        >;
                        extended?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_FragmentFragment
                                >
                            >
                        >;
                        featured?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_FragmentFragment
                                >
                            >
                        >;
                    }
                >;
                links?: Types.Maybe<
                    { __typename?: 'Links' } & Links_FragmentFragment
                >;
                seoBlurb?: Types.Maybe<
                    { __typename?: 'SeoBlurb' } & Seo_Blurb_FragmentFragment
                >;
                savedSearchAndAlerts?: Types.Maybe<
                    {
                        __typename?: 'SavedSearchAndAlerts';
                    } & Saved_Search_And_Alerts_FragmentFragment
                >;
            }
    >;
};

export type UserFavouritesQueryVariables = Types.Exact<{
    [key: string]: never;
}>;

export type UserFavouritesQuery = { __typename?: 'Query' } & {
    favourites?: Types.Maybe<
        { __typename?: 'Favourites' } & Pick<Types.Favourites, 'listings'>
    >;
};

export type FavouriteListingMutationVariables = Types.Exact<{
    id: Types.Scalars['ID'];
}>;

export type FavouriteListingMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'saveFavouriteListing'
>;

export type UnfavouriteListingMutationVariables = Types.Exact<{
    id: Types.Scalars['ID'];
}>;

export type UnfavouriteListingMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'deleteFavouriteListing'
>;

export type EmailAllMutationVariables = Types.Exact<{
    input: Types.EmailAllDetails;
}>;

export type EmailAllMutation = { __typename?: 'Mutation' } & {
    contactAgents?: Types.Maybe<
        { __typename?: 'EmailAllSubmission' } & {
            emailAll?: Types.Maybe<
                { __typename?: 'EmailAll' } & Pick<
                    Types.EmailAll,
                    'action' | 'showCaptcha'
                > & {
                        branches?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllBranchContact';
                                    } & Pick<
                                        Types.EmailAllBranchContact,
                                        | 'checked'
                                        | 'featured'
                                        | 'label'
                                        | 'logo'
                                        | 'name'
                                        | 'type'
                                        | 'telephone'
                                        | 'value'
                                    >
                                >
                            >
                        >;
                        branchesValidation?: Types.Maybe<
                            { __typename?: 'BranchesValidation' } & Pick<
                                Types.BranchesValidation,
                                'requiredError'
                            >
                        >;
                        formConfig?: Types.Maybe<
                            { __typename?: 'EmailAllFormConfig' } & {
                                fields?: Types.Maybe<
                                    Array<
                                        Types.Maybe<
                                            {
                                                __typename?: 'EmailAllFormConfigFields';
                                            } & {
                                                fieldset?: Types.Maybe<
                                                    {
                                                        __typename?: 'EmailAllFormConfigFieldset';
                                                    } & Pick<
                                                        Types.EmailAllFormConfigFieldset,
                                                        | 'hideLegend'
                                                        | 'i18NLegendKey'
                                                        | 'name'
                                                    > & {
                                                            fields?: Types.Maybe<
                                                                Array<
                                                                    Types.Maybe<
                                                                        {
                                                                            __typename?: 'EmailAllFormField';
                                                                        } & Pick<
                                                                            Types.EmailAllFormField,
                                                                            | 'name'
                                                                            | 'placeholder'
                                                                            | 'type'
                                                                            | 'value'
                                                                            | 'i18NLabelKey'
                                                                            | 'maxlength'
                                                                            | 'optional'
                                                                        > & {
                                                                                validationData?: Types.Maybe<
                                                                                    {
                                                                                        __typename?: 'EmailAllFormFieldValidation';
                                                                                    } & Pick<
                                                                                        Types.EmailAllFormFieldValidation,
                                                                                        | 'pattern'
                                                                                        | 'patternError'
                                                                                        | 'required'
                                                                                        | 'requiredError'
                                                                                    >
                                                                                >;
                                                                                options?: Types.Maybe<
                                                                                    Array<
                                                                                        Types.Maybe<
                                                                                            {
                                                                                                __typename?: 'EmailAllOption';
                                                                                            } & Pick<
                                                                                                Types.EmailAllOption,
                                                                                                | 'disabled'
                                                                                                | 'i18NLabelKey'
                                                                                                | 'label'
                                                                                                | 'selected'
                                                                                                | 'value'
                                                                                            >
                                                                                        >
                                                                                    >
                                                                                >;
                                                                            }
                                                                    >
                                                                >
                                                            >;
                                                        }
                                                >;
                                            }
                                        >
                                    >
                                >;
                            }
                        >;
                    }
            >;
            result?: Types.Maybe<
                { __typename?: 'EmailAllResult' } & Pick<
                    Types.EmailAllResult,
                    'leadIdentifier' | 'message'
                > & {
                        branches?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllResultBranches';
                                    } & Pick<
                                        Types.EmailAllResultBranches,
                                        | 'address'
                                        | 'branchDetailsUri'
                                        | 'branchDetailsUrl'
                                        | 'branchId'
                                        | 'companyId'
                                        | 'companyName'
                                        | 'logoUrl'
                                        | 'memberType'
                                        | 'name'
                                        | 'phone'
                                        | 'postcode'
                                    >
                                >
                            >
                        >;
                        trackingObjects?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllResultTracking';
                                    } & {
                                        ecommerce?: Types.Maybe<
                                            {
                                                __typename?: 'EmailAllResultEcommerce';
                                            } & {
                                                purchase?: Types.Maybe<
                                                    {
                                                        __typename?: 'EmailAllResultEcommercePurchase';
                                                    } & {
                                                        actionField?: Types.Maybe<
                                                            {
                                                                __typename?: 'EmailAllResultEcommercePurchaseAction';
                                                            } & Pick<
                                                                Types.EmailAllResultEcommercePurchaseAction,
                                                                | 'affiliation'
                                                                | 'id'
                                                                | 'revenue'
                                                            >
                                                        >;
                                                        products?: Types.Maybe<
                                                            Array<
                                                                Types.Maybe<
                                                                    {
                                                                        __typename?: 'EmailAllResultEcommerceProduct';
                                                                    } & Pick<
                                                                        Types.EmailAllResultEcommerceProduct,
                                                                        | 'brand'
                                                                        | 'category'
                                                                        | 'coupon'
                                                                        | 'id'
                                                                        | 'name'
                                                                        | 'position'
                                                                        | 'price'
                                                                        | 'quantity'
                                                                        | 'variant'
                                                                    >
                                                                >
                                                            >
                                                        >;
                                                    }
                                                >;
                                            }
                                        >;
                                    }
                                >
                            >
                        >;
                    }
            >;
        }
    >;
};

export type GetEmailAllQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetEmailAllQuery = { __typename?: 'Query' } & {
    emailAll?: Types.Maybe<
        { __typename?: 'EmailAll' } & Pick<
            Types.EmailAll,
            'action' | 'showCaptcha'
        > & {
                branches?: Types.Maybe<
                    Array<
                        Types.Maybe<
                            { __typename?: 'EmailAllBranchContact' } & Pick<
                                Types.EmailAllBranchContact,
                                | 'checked'
                                | 'featured'
                                | 'label'
                                | 'logo'
                                | 'name'
                                | 'type'
                                | 'telephone'
                                | 'value'
                            >
                        >
                    >
                >;
                formConfig?: Types.Maybe<
                    { __typename?: 'EmailAllFormConfig' } & {
                        fields?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllFormConfigFields';
                                    } & {
                                        fieldset?: Types.Maybe<
                                            {
                                                __typename?: 'EmailAllFormConfigFieldset';
                                            } & Pick<
                                                Types.EmailAllFormConfigFieldset,
                                                | 'hideLegend'
                                                | 'i18NLegendKey'
                                                | 'name'
                                            > & {
                                                    fields?: Types.Maybe<
                                                        Array<
                                                            Types.Maybe<
                                                                {
                                                                    __typename?: 'EmailAllFormField';
                                                                } & Pick<
                                                                    Types.EmailAllFormField,
                                                                    | 'name'
                                                                    | 'placeholder'
                                                                    | 'type'
                                                                    | 'value'
                                                                    | 'i18NLabelKey'
                                                                    | 'maxlength'
                                                                    | 'optional'
                                                                > & {
                                                                        validationData?: Types.Maybe<
                                                                            {
                                                                                __typename?: 'EmailAllFormFieldValidation';
                                                                            } & Pick<
                                                                                Types.EmailAllFormFieldValidation,
                                                                                | 'pattern'
                                                                                | 'required'
                                                                            >
                                                                        >;
                                                                        options?: Types.Maybe<
                                                                            Array<
                                                                                Types.Maybe<
                                                                                    {
                                                                                        __typename?: 'EmailAllOption';
                                                                                    } & Pick<
                                                                                        Types.EmailAllOption,
                                                                                        | 'disabled'
                                                                                        | 'i18NLabelKey'
                                                                                        | 'label'
                                                                                        | 'selected'
                                                                                        | 'value'
                                                                                    >
                                                                                >
                                                                            >
                                                                        >;
                                                                    }
                                                            >
                                                        >
                                                    >;
                                                }
                                        >;
                                    }
                                >
                            >
                        >;
                    }
                >;
            }
    >;
};

export type GetListingDataV2QueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetListingDataV2Query = { __typename?: 'Query' } & {
    breadcrumbs?: Types.Maybe<
        Array<
            { __typename?: 'Breadcrumbs' } & Pick<
                Types.Breadcrumbs,
                'label' | 'tracking' | 'uri' | 'noAppend' | 'i18nLabelKey'
            >
        >
    >;
    redirects?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'Redirect' } & Pick<
                    Types.Redirect,
                    'code' | 'redirectUri'
                >
            >
        >
    >;
    seoAccordions?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'SeoAccordions' } & Pick<
                    Types.SeoAccordions,
                    | 'category'
                    | 'expanded'
                    | 'geo'
                    | 'name'
                    | 'propertyType'
                    | 'section'
                    | 'transactionType'
                > & {
                        rows?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Row' } & {
                                        links?: Types.Maybe<
                                            Array<
                                                Types.Maybe<
                                                    {
                                                        __typename?: 'Link';
                                                    } & Pick<
                                                        Types.Link,
                                                        | 'category'
                                                        | 'geo'
                                                        | 'propertyType'
                                                        | 'section'
                                                        | 'transactionType'
                                                        | 'uri'
                                                    >
                                                >
                                            >
                                        >;
                                    }
                                >
                            >
                        >;
                        links?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Link' } & Pick<
                                        Types.Link,
                                        | 'category'
                                        | 'geo'
                                        | 'propertyType'
                                        | 'section'
                                        | 'transactionType'
                                        | 'uri'
                                    >
                                >
                            >
                        >;
                    }
            >
        >
    >;
    discoverMore?: Types.Maybe<
        { __typename?: 'DiscoverMore' } & Pick<
            Types.DiscoverMore,
            'housePricesUri' | 'findAgentsUri'
        >
    >;
    searchResultsV2?: Types.Maybe<
        { __typename?: 'ResultsV2' } & Pick<
            Types.ResultsV2,
            'title' | 'userAlertId' | 'polyenc'
        > & {
                analyticsTaxonomy?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsTaxonomy';
                    } & Analytics_Taxonomy_FragmentFragment
                >;
                analyticsEcommerce?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsEcommerce';
                    } & Analytics_Eccomerce_FragmentFragment
                >;
                adTargeting?: Types.Maybe<
                    {
                        __typename?: 'AdTargeting';
                    } & Ad_Targeting_FragmentFragment
                >;
                metaInfo?: Types.Maybe<
                    { __typename?: 'Meta' } & Meta_Info_FragmentFragment
                >;
                pagination?: Types.Maybe<
                    { __typename?: 'Pagination' } & Pagination_FragmentFragment
                >;
                results?: Types.Maybe<
                    { __typename?: 'ResultsList' } & {
                        main?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'ResultsItem' } & {
                                        data?: Types.Maybe<
                                            {
                                                __typename?: 'FeedListingItem';
                                            } & Pick<
                                                Types.FeedListingItem,
                                                'presentationType'
                                            > & {
                                                    listing?: Types.Maybe<
                                                        {
                                                            __typename?: 'Listing';
                                                        } & Listing_FragmentFragment
                                                    >;
                                                }
                                        >;
                                    }
                                >
                            >
                        >;
                        extended?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_FragmentFragment
                                >
                            >
                        >;
                    }
                >;
                links?: Types.Maybe<
                    { __typename?: 'Links' } & Links_FragmentFragment
                >;
                seoBlurb?: Types.Maybe<
                    { __typename?: 'SeoBlurb' } & Seo_Blurb_FragmentFragment
                >;
                savedSearchAndAlerts?: Types.Maybe<
                    {
                        __typename?: 'SavedSearchAndAlerts';
                    } & Saved_Search_And_Alerts_FragmentFragment
                >;
            }
    >;
};

export const LogSearchDocument = gql`
    mutation logSearch($path: String!) {
        logSearch(url: $path)
    }
`;
export type LogSearchMutationFn = Apollo.MutationFunction<
    LogSearchMutation,
    LogSearchMutationVariables
>;

/**
 * __useLogSearchMutation__
 *
 * To run a mutation, you first call `useLogSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logSearchMutation, { data, loading, error }] = useLogSearchMutation({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useLogSearchMutation(
    baseOptions?: Apollo.MutationHookOptions<
        LogSearchMutation,
        LogSearchMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<LogSearchMutation, LogSearchMutationVariables>(
        LogSearchDocument,
        options
    );
}
export type LogSearchMutationHookResult = ReturnType<
    typeof useLogSearchMutation
>;
export type LogSearchMutationResult = Apollo.MutationResult<LogSearchMutation>;
export type LogSearchMutationOptions = Apollo.BaseMutationOptions<
    LogSearchMutation,
    LogSearchMutationVariables
>;
export const ApiSearchByUrlDocument = gql`
    query apiSearchByUrl($path: String!) {
        seo(path: $path) {
            ... on SeoResults {
                ...SEO_FRAGMENT
            }
            ... on SeoResultsError {
                errorCode
            }
        }
        searchResults: searchByUrl(url: $path) {
            adTargeting {
                ...AD_TARGETING_FRAGMENT
            }
            analyticsEcommerce {
                ...ANALYTICS_ECCOMERCE_FRAGMENT
            }
            analyticsTaxonomy {
                ...ANALYTICS_TAXONOMY_FRAGMENT
            }
            links {
                ...LINKS_FRAGMENT
            }
            listings {
                regular {
                    ...LISTING_SS_FRAGMENT
                }
                extended {
                    ...LISTING_SS_FRAGMENT
                }
                featured {
                    ...LISTING_SS_FRAGMENT
                }
            }
            metaInfo {
                ...META_INFO_FRAGMENT
            }
            pagination {
                ...PAGINATION_FRAGMENT
            }
            savedSearchAndAlerts {
                ...SAVED_SEARCH_AND_ALERTS_FRAGMENT
            }
            seoBlurb {
                ...SEO_BLURB_FRAGMENT
            }
            title
            userAlertId
        }
    }
    ${Seo_FragmentFragmentDoc}
    ${Ad_Targeting_FragmentFragmentDoc}
    ${Analytics_Eccomerce_FragmentFragmentDoc}
    ${Analytics_Taxonomy_FragmentFragmentDoc}
    ${Links_FragmentFragmentDoc}
    ${Listing_Ss_FragmentFragmentDoc}
    ${Meta_Info_FragmentFragmentDoc}
    ${Pagination_FragmentFragmentDoc}
    ${Saved_Search_And_Alerts_FragmentFragmentDoc}
    ${Seo_Blurb_FragmentFragmentDoc}
`;

/**
 * __useApiSearchByUrlQuery__
 *
 * To run a query within a React component, call `useApiSearchByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiSearchByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiSearchByUrlQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useApiSearchByUrlQuery(
    baseOptions: Apollo.QueryHookOptions<
        ApiSearchByUrlQuery,
        ApiSearchByUrlQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ApiSearchByUrlQuery, ApiSearchByUrlQueryVariables>(
        ApiSearchByUrlDocument,
        options
    );
}
export function useApiSearchByUrlLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ApiSearchByUrlQuery,
        ApiSearchByUrlQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        ApiSearchByUrlQuery,
        ApiSearchByUrlQueryVariables
    >(ApiSearchByUrlDocument, options);
}
export type ApiSearchByUrlQueryHookResult = ReturnType<
    typeof useApiSearchByUrlQuery
>;
export type ApiSearchByUrlLazyQueryHookResult = ReturnType<
    typeof useApiSearchByUrlLazyQuery
>;
export type ApiSearchByUrlQueryResult = Apollo.QueryResult<
    ApiSearchByUrlQuery,
    ApiSearchByUrlQueryVariables
>;
export const GetListingDataDocument = gql`
    query getListingData($path: String!) {
        breadcrumbs(path: $path) {
            label
            tracking
            uri
            noAppend
            i18nLabelKey
        }
        redirects(path: $path) {
            code
            redirectUri
        }
        seoAccordions(path: $path) {
            ...SEO_ACCORDIONS_FRAGMENT
        }
        discoverMore(path: $path) {
            housePricesUri
            findAgentsUri
        }
        searchResults(path: $path) {
            analyticsTaxonomy {
                ...ANALYTICS_TAXONOMY_FRAGMENT
            }
            analyticsEcommerce {
                ...ANALYTICS_ECCOMERCE_FRAGMENT
            }
            adTargeting {
                ...AD_TARGETING_FRAGMENT
            }
            metaInfo {
                ...META_INFO_FRAGMENT
            }
            pagination {
                ...PAGINATION_FRAGMENT
            }
            listings {
                regular {
                    ...LISTING_FRAGMENT
                }
                extended {
                    ...LISTING_FRAGMENT
                }
                featured {
                    ...LISTING_FRAGMENT
                }
            }
            links {
                ...LINKS_FRAGMENT
            }
            seoBlurb {
                ...SEO_BLURB_FRAGMENT
            }
            title
            userAlertId
            savedSearchAndAlerts {
                ...SAVED_SEARCH_AND_ALERTS_FRAGMENT
            }
            polyenc
        }
    }
    ${Seo_Accordions_FragmentFragmentDoc}
    ${Analytics_Taxonomy_FragmentFragmentDoc}
    ${Analytics_Eccomerce_FragmentFragmentDoc}
    ${Ad_Targeting_FragmentFragmentDoc}
    ${Meta_Info_FragmentFragmentDoc}
    ${Pagination_FragmentFragmentDoc}
    ${Listing_FragmentFragmentDoc}
    ${Links_FragmentFragmentDoc}
    ${Seo_Blurb_FragmentFragmentDoc}
    ${Saved_Search_And_Alerts_FragmentFragmentDoc}
`;

/**
 * __useGetListingDataQuery__
 *
 * To run a query within a React component, call `useGetListingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingDataQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetListingDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetListingDataQuery,
        GetListingDataQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetListingDataQuery, GetListingDataQueryVariables>(
        GetListingDataDocument,
        options
    );
}
export function useGetListingDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetListingDataQuery,
        GetListingDataQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetListingDataQuery,
        GetListingDataQueryVariables
    >(GetListingDataDocument, options);
}
export type GetListingDataQueryHookResult = ReturnType<
    typeof useGetListingDataQuery
>;
export type GetListingDataLazyQueryHookResult = ReturnType<
    typeof useGetListingDataLazyQuery
>;
export type GetListingDataQueryResult = Apollo.QueryResult<
    GetListingDataQuery,
    GetListingDataQueryVariables
>;
export const UserFavouritesDocument = gql`
    query userFavourites {
        favourites {
            listings
        }
    }
`;

/**
 * __useUserFavouritesQuery__
 *
 * To run a query within a React component, call `useUserFavouritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFavouritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFavouritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserFavouritesQuery(
    baseOptions?: Apollo.QueryHookOptions<
        UserFavouritesQuery,
        UserFavouritesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<UserFavouritesQuery, UserFavouritesQueryVariables>(
        UserFavouritesDocument,
        options
    );
}
export function useUserFavouritesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        UserFavouritesQuery,
        UserFavouritesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        UserFavouritesQuery,
        UserFavouritesQueryVariables
    >(UserFavouritesDocument, options);
}
export type UserFavouritesQueryHookResult = ReturnType<
    typeof useUserFavouritesQuery
>;
export type UserFavouritesLazyQueryHookResult = ReturnType<
    typeof useUserFavouritesLazyQuery
>;
export type UserFavouritesQueryResult = Apollo.QueryResult<
    UserFavouritesQuery,
    UserFavouritesQueryVariables
>;
export const FavouriteListingDocument = gql`
    mutation favouriteListing($id: ID!) {
        saveFavouriteListing(id: $id)
    }
`;
export type FavouriteListingMutationFn = Apollo.MutationFunction<
    FavouriteListingMutation,
    FavouriteListingMutationVariables
>;

/**
 * __useFavouriteListingMutation__
 *
 * To run a mutation, you first call `useFavouriteListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavouriteListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favouriteListingMutation, { data, loading, error }] = useFavouriteListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFavouriteListingMutation(
    baseOptions?: Apollo.MutationHookOptions<
        FavouriteListingMutation,
        FavouriteListingMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        FavouriteListingMutation,
        FavouriteListingMutationVariables
    >(FavouriteListingDocument, options);
}
export type FavouriteListingMutationHookResult = ReturnType<
    typeof useFavouriteListingMutation
>;
export type FavouriteListingMutationResult =
    Apollo.MutationResult<FavouriteListingMutation>;
export type FavouriteListingMutationOptions = Apollo.BaseMutationOptions<
    FavouriteListingMutation,
    FavouriteListingMutationVariables
>;
export const UnfavouriteListingDocument = gql`
    mutation unfavouriteListing($id: ID!) {
        deleteFavouriteListing(id: $id)
    }
`;
export type UnfavouriteListingMutationFn = Apollo.MutationFunction<
    UnfavouriteListingMutation,
    UnfavouriteListingMutationVariables
>;

/**
 * __useUnfavouriteListingMutation__
 *
 * To run a mutation, you first call `useUnfavouriteListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfavouriteListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfavouriteListingMutation, { data, loading, error }] = useUnfavouriteListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnfavouriteListingMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UnfavouriteListingMutation,
        UnfavouriteListingMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UnfavouriteListingMutation,
        UnfavouriteListingMutationVariables
    >(UnfavouriteListingDocument, options);
}
export type UnfavouriteListingMutationHookResult = ReturnType<
    typeof useUnfavouriteListingMutation
>;
export type UnfavouriteListingMutationResult =
    Apollo.MutationResult<UnfavouriteListingMutation>;
export type UnfavouriteListingMutationOptions = Apollo.BaseMutationOptions<
    UnfavouriteListingMutation,
    UnfavouriteListingMutationVariables
>;
export const EmailAllDocument = gql`
    mutation emailAll($input: EmailAllDetails!) {
        contactAgents(input: $input) {
            emailAll {
                action
                branches {
                    checked
                    featured
                    label
                    logo
                    name
                    type
                    telephone
                    value
                }
                branchesValidation {
                    requiredError
                }
                formConfig {
                    fields {
                        fieldset {
                            fields {
                                name
                                placeholder
                                type
                                value
                                i18NLabelKey
                                maxlength
                                optional
                                validationData {
                                    pattern
                                    patternError
                                    required
                                    requiredError
                                }
                                options {
                                    disabled
                                    i18NLabelKey
                                    label
                                    selected
                                    value
                                }
                            }
                            hideLegend
                            i18NLegendKey
                            name
                        }
                    }
                }
                showCaptcha
            }
            result {
                branches {
                    address
                    branchDetailsUri
                    branchDetailsUrl
                    branchId
                    companyId
                    companyName
                    logoUrl
                    memberType
                    name
                    phone
                    postcode
                }
                leadIdentifier
                message
                trackingObjects {
                    ecommerce {
                        purchase {
                            actionField {
                                affiliation
                                id
                                revenue
                            }
                            products {
                                brand
                                category
                                coupon
                                id
                                name
                                position
                                price
                                quantity
                                variant
                            }
                        }
                    }
                }
            }
        }
    }
`;
export type EmailAllMutationFn = Apollo.MutationFunction<
    EmailAllMutation,
    EmailAllMutationVariables
>;

/**
 * __useEmailAllMutation__
 *
 * To run a mutation, you first call `useEmailAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailAllMutation, { data, loading, error }] = useEmailAllMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailAllMutation(
    baseOptions?: Apollo.MutationHookOptions<
        EmailAllMutation,
        EmailAllMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<EmailAllMutation, EmailAllMutationVariables>(
        EmailAllDocument,
        options
    );
}
export type EmailAllMutationHookResult = ReturnType<typeof useEmailAllMutation>;
export type EmailAllMutationResult = Apollo.MutationResult<EmailAllMutation>;
export type EmailAllMutationOptions = Apollo.BaseMutationOptions<
    EmailAllMutation,
    EmailAllMutationVariables
>;
export const GetEmailAllDocument = gql`
    query getEmailAll($path: String!) {
        emailAll(path: $path) {
            action
            branches {
                checked
                featured
                label
                logo
                name
                type
                telephone
                value
            }
            formConfig {
                fields {
                    fieldset {
                        fields {
                            name
                            placeholder
                            type
                            value
                            i18NLabelKey
                            maxlength
                            optional
                            validationData {
                                pattern
                                required
                            }
                            options {
                                disabled
                                i18NLabelKey
                                label
                                selected
                                value
                            }
                        }
                        hideLegend
                        i18NLegendKey
                        name
                    }
                }
            }
            showCaptcha
        }
    }
`;

/**
 * __useGetEmailAllQuery__
 *
 * To run a query within a React component, call `useGetEmailAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailAllQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetEmailAllQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetEmailAllQuery,
        GetEmailAllQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetEmailAllQuery, GetEmailAllQueryVariables>(
        GetEmailAllDocument,
        options
    );
}
export function useGetEmailAllLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetEmailAllQuery,
        GetEmailAllQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetEmailAllQuery, GetEmailAllQueryVariables>(
        GetEmailAllDocument,
        options
    );
}
export type GetEmailAllQueryHookResult = ReturnType<typeof useGetEmailAllQuery>;
export type GetEmailAllLazyQueryHookResult = ReturnType<
    typeof useGetEmailAllLazyQuery
>;
export type GetEmailAllQueryResult = Apollo.QueryResult<
    GetEmailAllQuery,
    GetEmailAllQueryVariables
>;
export const GetListingDataV2Document = gql`
    query getListingDataV2($path: String!) {
        breadcrumbs(path: $path) {
            label
            tracking
            uri
            noAppend
            i18nLabelKey
        }
        redirects(path: $path) {
            code
            redirectUri
        }
        seoAccordions(path: $path) {
            category
            expanded
            geo
            name
            propertyType
            section
            transactionType
            rows {
                links {
                    category
                    geo
                    propertyType
                    section
                    transactionType
                    uri
                }
            }
            links {
                category
                geo
                propertyType
                section
                transactionType
                uri
            }
        }
        discoverMore(path: $path) {
            housePricesUri
            findAgentsUri
        }
        searchResultsV2(input: { path: $path }) {
            analyticsTaxonomy {
                ...ANALYTICS_TAXONOMY_FRAGMENT
            }
            analyticsEcommerce {
                ...ANALYTICS_ECCOMERCE_FRAGMENT
            }
            adTargeting {
                ...AD_TARGETING_FRAGMENT
            }
            metaInfo {
                ...META_INFO_FRAGMENT
            }
            pagination {
                ...PAGINATION_FRAGMENT
            }
            results {
                main {
                    data {
                        ... on FeedListingItem {
                            listing {
                                ...LISTING_FRAGMENT
                            }
                            presentationType
                        }
                    }
                }
                extended {
                    ...LISTING_FRAGMENT
                }
            }
            links {
                ...LINKS_FRAGMENT
            }
            seoBlurb {
                ...SEO_BLURB_FRAGMENT
            }
            title
            userAlertId
            savedSearchAndAlerts {
                ...SAVED_SEARCH_AND_ALERTS_FRAGMENT
            }
            polyenc
        }
    }
    ${Analytics_Taxonomy_FragmentFragmentDoc}
    ${Analytics_Eccomerce_FragmentFragmentDoc}
    ${Ad_Targeting_FragmentFragmentDoc}
    ${Meta_Info_FragmentFragmentDoc}
    ${Pagination_FragmentFragmentDoc}
    ${Listing_FragmentFragmentDoc}
    ${Links_FragmentFragmentDoc}
    ${Seo_Blurb_FragmentFragmentDoc}
    ${Saved_Search_And_Alerts_FragmentFragmentDoc}
`;

/**
 * __useGetListingDataV2Query__
 *
 * To run a query within a React component, call `useGetListingDataV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetListingDataV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingDataV2Query({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetListingDataV2Query(
    baseOptions: Apollo.QueryHookOptions<
        GetListingDataV2Query,
        GetListingDataV2QueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetListingDataV2Query,
        GetListingDataV2QueryVariables
    >(GetListingDataV2Document, options);
}
export function useGetListingDataV2LazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetListingDataV2Query,
        GetListingDataV2QueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetListingDataV2Query,
        GetListingDataV2QueryVariables
    >(GetListingDataV2Document, options);
}
export type GetListingDataV2QueryHookResult = ReturnType<
    typeof useGetListingDataV2Query
>;
export type GetListingDataV2LazyQueryHookResult = ReturnType<
    typeof useGetListingDataV2LazyQuery
>;
export type GetListingDataV2QueryResult = Apollo.QueryResult<
    GetListingDataV2Query,
    GetListingDataV2QueryVariables
>;
